import { Injectable } from '@angular/core';
import { ApiService, ILegalCompany, IUserCompany, navigationHelper } from '@cakeiteasy/web-utils';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CompanyApiService {
  constructor(private _api: ApiService) {
  }

  public createCompany(legalCompany: ILegalCompany): Observable<IUserCompany> {
    return this._api.post('api.company', 'companies', {},
      { legalCompany });
  }

  public createBakeryCompany(bakeryId: number, legalCompany: ILegalCompany): Observable<IUserCompany> {
    return this._api.post('api.company', 'bakeries_companies', { bakeryId },
      { legalCompany });
  }

  public searchCompany(countryCode: string, orgNumber: string): Observable<ILegalCompany> {
    return this._api.get('api.legalCompany', 'external_lookup', { countryCode, orgNumber });
  }

  public searchOrCreateCompany(
    params: { orgNumber: any, countryCode: any, companyType: string, bakeryId?: number, companyName?: string }
  ): Observable<IUserCompany> {
    const {
      orgNumber, countryCode, companyType, bakeryId, companyName
    } = params;

    const queryParams = {
      orgNumber: encodeURIComponent(orgNumber),
      name: encodeURIComponent(companyName),
      'fetch_from_brreg': true,
      type: companyType,
      'country': countryCode,
      bakeryId
    };

    return this._api.get('api.company',
      'companies', null, { params: queryParams });
  }

  public searchCompanyByQuery(query: string, country: string): Observable<{ results: { id: string, name: string }[], total: number }> {
    const params = { limit: 100, offset: '0', query, country };
    return this._api.get('api.company', 'companies_search', null, { params });
  }
}
